<template>
    <div class="flex flex-col relative overflow-hidden w-full h-full items-center justify-center pt-10 xl:pt-0 ">
        <div v-if="qrcreate.imageData"
            class="xs:p-10 p-4 sm:max-w-md xs:max-w-sm max-w-xs bg-white drop-shadow-2xl relative">
            <img :src="qrcreate.imageData" class="xl:max-w-full max-w-[80%] mx-auto" />
            <span class="absolute bottom-0 right-0 text-xs">Artboard</span>
        </div>
        <div v-else class="xs:p-10 p-4 sm:max-w-md xs:max-w-sm max-w-xs bg-white drop-shadow-2xl relative">
            <img src="https://app.qrgateway.com/images/qrcode-none-new.png" class="xl:max-w-full max-w-[80%] mx-auto" />
            <span class="absolute bottom-0 right-0 text-xs">no data yet</span>
        </div>
    </div>
</template>
<script lang="ts" setup>
import { storeToRefs } from 'pinia';
import { useQrCreateStore } from '~~/stores/qrcreate';

const qrcreate = useQrCreateStore()

const { config } = storeToRefs(qrcreate)
const qrstyle = useQrStyle()
onMounted(() => {
    qrstyle.ImportFont()
})
watchDebounced(config, (v) => {
    nextTick(() => {
        qrstyle.GenerateQrCode({ stack: false })
    })
}, { deep: true, debounce: 100, maxWait: 5000 })
</script>